import { observer } from 'src/utils/mobx-react';
import {
    ItemButton,
    ItemWrapper,
    VerticalMoveIconWrapper,
} from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.style';
import React from 'react';
import { OpenapiProxyStaffGetMarketTemplatesResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_get_market_templates';
import { MarketTemplateSettingsForm } from 'src/components/MarketTemplateSettingsForm/MarketTemplateSettingsForm';
import { SportMarketTemplatesState } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.state';
function stopPropagation(e: unknown): void {
    // @ts-expect-error
    e.stopPropagation();
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export type MarketTemplateItem =
    OpenapiProxyStaffGetMarketTemplatesResponse200Type['results'] extends Array<infer Inner> ? Inner : never;
interface MarketTemplatesItemPropsType {
    templateId: string;
    sportId: string;
    isDragged: boolean;
    marketTemplatesState: SportMarketTemplatesState;
}

export const SportMarketTemplatesItem = observer('SportMarketTemplatesItem', (props: MarketTemplatesItemPropsType) => {
    const template = props.marketTemplatesState.marketTemplateByIt(props.templateId);

    return (
        <ItemWrapper>
            <span title={props.marketTemplatesState.geniusTemplateKeys.has(props.templateId) ? 'Genius' : undefined}>
                {template === 'loading' ? 'loading' : template.marketName}
            </span>
            <ItemButton
                isDragged={props.isDragged}
                data-movable-handle
                tabIndex={-1}
            >
                <VerticalMoveIconWrapper />
            </ItemButton>
            {props.marketTemplatesState.expendedList.includes(props.templateId) ? (
                <div
                    className='sport-templates__details'
                    onClick={stopPropagation}
                >
                    <MarketTemplateSettingsForm
                        sportId={props.sportId}
                        templateId={props.templateId}
                        marketTemplatesState={props.marketTemplatesState}
                    />
                </div>
            ) : null}
        </ItemWrapper>
    );
});
